import axios from 'axios';

const deletePaymentProducts = async (token, id) => {
  const formData = new FormData()
  formData.append('id', id)
  try {
    const res = await axios.post(
      '/receipts/delete',
      formData,
      {
        baseURL: process.env.REACT_APP_BASE_URL,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'applications/json',
          Authorization: 'Bearer ' + token,
        }
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export default deletePaymentProducts;
